export const getCsrfToken = () => {
  const csrfTokenMeta = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]');
  if (csrfTokenMeta) {
    return csrfTokenMeta.content;
  }
  return null;
};
